
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const DoucheSeniorPage = lazy(() => import('../pages/douche-senior/page'));
const PompeAChaleurPage = lazy(() => import('../pages/pompe-a-chaleur/page'));
const RenovationAmpleurPage = lazy(() => import('../pages/renovation-ampleur/page'));
const RenovationTertiairePage = lazy(() => import('../pages/renovation-tertiaire/page'));
const MentionsLegalesPage = lazy(() => import('../pages/mentions-legales/page'));
const PolitiqueConfidentialitePage = lazy(() => import('../pages/politique-confidentialite/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogArticlePage = lazy(() => import('../pages/blog/[slug]/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/douche-senior',
    element: <DoucheSeniorPage />,
  },
  {
    path: '/pompe-a-chaleur',
    element: <PompeAChaleurPage />,
  },
  {
    path: '/renovation-ampleur',
    element: <RenovationAmpleurPage />,
  },
  {
    path: '/renovation-tertiaire',
    element: <RenovationTertiairePage />,
  },
  {
    path: '/mentions-legales',
    element: <MentionsLegalesPage />,
  },
  {
    path: '/politique-confidentialite',
    element: <PolitiqueConfidentialitePage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogArticlePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
